import React from 'react';
import Hero from '../components/Hero';
import EventPreview from '../components/EventPreview';
// import FeaturedNews from '../components/FeaturedNews';
// import VideoSection from '../components/VideoSection';
import './HomePage.css';

export default function HomePage() {
  return (
    <>
      <Hero />
      <EventPreview />
      {/* Hidden until we have content ready
      <FeaturedNews />
      <VideoSection />
      */}
    </>
  );
}
